export default {
    fadak: 'فدک',
    raja: 'رجا',
    bonrail: 'ریل',
};
